module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.openModal === true) ? _c('div', {
    staticClass: "modal",
    class: {
      visible: _vm.openModal
    }
  }, [_c('div', {
    staticClass: "frame visible",
    staticStyle: {
      "background-image": "url('https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4119/dist/assets/img/background-image.png')"
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fa far fa-times"
  })]), _vm._v(" "), (_vm.modalType === 'postcodeInfo') ? _c('div', {
    staticClass: "postcode-info"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-down",
    on: {
      "click": _vm.scrollToInput
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isError) ? _c('div', {
    staticClass: "error-modal"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.errorText[_vm.modalType]))]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "name": "dismiss"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n          Dismiss\n        ")])])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details"
  }, [_c('h2', [_vm._v("Find threatened species near you")]), _vm._v(" "), _c('p', [_vm._v("\n          Use your address to locate endangered species in your neighbourhood.\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('div', {
    staticClass: "error-icon",
    staticStyle: {
      "background-image": "url('https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4119/dist/assets/img/error-icon.png')"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf907a28","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=1udq9m5yalv!./~/string-replace-webpack-plugin/loader.js?id=5v3roo83miv!./src/components/threatened-species/ThreatenedSpeciesModal.vue
// module id = 800
// module chunks = 0